let cachedCutoffAbbreviatedTimeZone: string;

/**
 * Returns the abbreviation of the device's current timezone (e.g., EST)
 *
 * Product has expressed interest in showing the user the cutoff date in
 * the timezone of their delivery address. When/if that time comes, it'll be
 * easier to modify this function and determine the who the consumers are.
 */
export function getCutoffTimeZoneAbbreviation() {
  if (cachedCutoffAbbreviatedTimeZone) {
    return cachedCutoffAbbreviatedTimeZone;
  }

  // The `en-US` locale will satisfy our case cases for the time being.
  // Globalization will require a more comprehensive solution. For those
  // outside of the locale, the timezone abbreviation will result in a less
  // user-friendly format (e.g., User in Tokyo will see "GMT+9" instead of "JST").
  const timeZonePart = new Intl.DateTimeFormat('en-US', {
    timeZoneName: 'short',
  })
    .formatToParts(new Date())
    .find((part) => part.type == 'timeZoneName');

  cachedCutoffAbbreviatedTimeZone = timeZonePart ? timeZonePart.value : '';

  return cachedCutoffAbbreviatedTimeZone;
}

/**
 * Clears the cached cutoff time zone abbreviation. This is useful for
 * testing purposes.
 */
export function clearCachedCutoffTimeZoneAbbreviation() {
  cachedCutoffAbbreviatedTimeZone = '';
}
